import { createSeniorFlowTab } from './seniorFlowTabFactory';
import { locationAvailabilityColumn } from './LocationAvailabilityCell';
import { registerTab } from './tabRegistry';

// senior_level_flow — "New" tab. manual_actions: send_contact_link,
// remove_from_pipeline (resolved generically via GenericFlowAction).
// This tab alone also gets the "Location & Availability" column — a fresh
// candidate is the point where knowing where they are / when they can start
// matters most for deciding whether to contact them. Where the candidate
// came from (candidate_source) is NOT a dedicated column here — it's
// available on every tab's row data, not just New, so it renders as a small
// badge on the avatar inside the shared Candidate column instead (see
// CandidateCell.jsx) rather than needing a per-tab opt-in.
const SeniorNewTab = createSeniorFlowTab(
  'New',
  'No new candidates in this pipeline yet.',
  { extraColumns: [locationAvailabilityColumn] }
);

registerTab({
  stateMachineKey: 'senior_level_flow',
  state: 'New',
  component: SeniorNewTab,
});

export default SeniorNewTab;
